import { api } from '../../lib/api';
import type { KyckConnectOverviewResponse } from '../../types/kyckConnectOverview';

// /api/kyckconnect/overview is ADMIN ONLY (the server refuses anyone else before it reads anything).
export const fetchOverview = () => api<KyckConnectOverviewResponse>('/api/kyckconnect/overview');
